// A fold: a header that stays put, and a body that opens and closes.
//
// The pattern was already hand-rolled twice — the board's ClientGroup and the Leads
// screen's LeadRow — and the client card's work tree needs it at two more levels
// (a retainer, and a job inside it). A third and fourth copy is where a shared
// component stops being optional, so the rules those two arrived at live here:
//
//   1. THE HEADER SHOWS EVERYTHING *ABOUT* THE RECORD; the fold only hides its
//      CONTENTS. Closing a fold must never hide a status, a count or an action.
//   2. THE IDENTITY IS THE HIT TARGET, not the chevron alone — a 12px glyph is a
//      miserable thing to aim at, so the whole title block is the button.
//   3. INTERACTIVE CONTROLS SIT OUTSIDE THE BUTTON, in `meta`. A <select> or a
//      <button> cannot legally nest inside a <button>, and putting one there would
//      also make using it toggle the fold. That is why the header is a grid of two
//      siblings rather than one big button.
//   4. `badges` RIDE IN THE HEADER, open or closed. On the board the count appears
//      only when collapsed, because there the tasks themselves are the count once
//      you can see them. Here a job's "4 פרסומים" is worth reading either way: it is
//      what turns a retainer with a dozen topics into a scan rather than a hunt.
//
// `level` drives the indentation rail in styles/clientwork.css. It is presentational
// only — nothing here behaves differently by depth.
//
// `spin` renders a single chevron that ROTATES on open instead of swapping ▸ for ▾.
// Opt-in rather than the default: it is what a list of collapsed CARDS wants, where the
// fold is the main thing you do to the row, and it would be fidgety on the board's task
// groups. Both forms are hidden from screen readers — `aria-expanded` on the button is
// what actually announces the state.
export default function Collapsible({
  open, onToggle, title, badges, meta, level = 1, spin = false, children,
}) {
  return (
    <div className={`fold fold-l${level}${open ? ' open' : ''}`}>
      <div className="fold-head">
        <button type="button" className="fold-toggle" onClick={onToggle} aria-expanded={open}>
          {/* `spin` keeps ONE glyph and rotates it, so opening reads as a movement
              rather than a substitution — the affordance an accordion of whole cards
              needs, where the fold is the primary interaction rather than a detail of a
              tree. Opt-in: the existing folds swap ▸/▾ and are left exactly as they were,
              because a rotation animation on every row of the board is noise. */}
          <span className="chevron" aria-hidden="true">{spin ? '▸' : (open ? '▾' : '▸')}</span>
          <span className="fold-title">{title}</span>
          {badges && <span className="fold-badges">{badges}</span>}
        </button>
        {meta && <div className="fold-meta">{meta}</div>}
      </div>
      {open && <div className="fold-body">{children}</div>}
    </div>
  );
}
